export default __webpack_public_path__ + "static/media/logo_dawoo.045e1cef.png";